
export default{
    name: "FeatureCard",
    props: {
        FEATURES: Array,
    }
}
